<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Device Data</span>
    </div>
    <div
        class="card-content"
        style="height: 480px">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="device-image">
            <DeviceImage
                :device="device" />
          </div>
        </el-col>
        <el-col :span="20">
          <div class="device-row">
            <div class="device-row-label">
              ID
            </div>
            <div class="device-row-value">
              {{ device.doorbot_id | capitalize }}
            </div>
          </div>
          <div class="device-row">
            <div class="device-row-label">
              Type
            </div>
            <div class="device-row-value">
              {{ device.type | capitalize }}
            </div>
          </div>
          <div class="device-row">
            <div class="device-row-label">
              Name
            </div>
            <div class="device-row-value">
              <router-link :to="{ name: 'Device', params: {customer_id: customerId, doorbot_id: device.doorbot_id }}">
                {{ device.name | capitalize }}
              </router-link>
            </div>
          </div>
          <div class="device-row">
            <div class="device-row-label">
              Mac Address
            </div>
            <div class="device-row-value">
              {{ device.mac_address }}
            </div>
          </div>
          <div class="device-row">
            <div class="device-row-label">
              Power Source
            </div>
            <div class="device-row-value">
              {{ powerSourceFormatted(device.power_source) }}
            </div>
          </div>
          <div class="device-row">
            <div class="device-row-label">
              Location
            </div>
            <div class="device-row-value">
              {{ device.location_id }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { replace } from "lodash";
import DeviceImage from "@/components/Shared/DeviceImage";
const { mapActions: eventActions } = createNamespacedHelpers("event");
const { mapGetters: deviceGetters } = createNamespacedHelpers("db/device");

export default {
  name: "EventDeviceData",
  components: {
    DeviceImage,
  },
  props: {
    eventId: { type: [Number, String], required: true },
    doorbotId: { type: [Number, String], required: true },
    customerId: { type: [Number, String], required: true },
  },
  data() {
    return {
      loading: false,
      env: {},
    };
  },
  computed: {
    ...deviceGetters(["device"]),
  },
  created() {
    this.env = process.env;
    this.loadDevice();
  },
  methods: {
    ...eventActions(["fetchDeviceData"]),
    loadDevice() {
      this.loading = true;
      this.fetchDeviceData({ eventId: this.eventId, doorbotId: this.doorbotId })
        .then((device) => this.$emit("loaded", { device }))
        .catch((error) => {
          console.log("Error loading device", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pictureUrl(url) {
      let regexp = /https:\/\/localhost:\d{4}/;
      if (regexp.test(url)) {
        return replace(url, regexp, this.env.API_URL);
      } else return url;
    },
    powerSourceFormatted(status) {
      return status && status.replace(/Battery Battery/, "Battery");
    },
  },
};
</script>

<style lang="scss" scoped>
.device-row {
  border-bottom: dashed 1px #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0px 15px;
  .device-row-label {
    font-size: 1rem;
    flex: 1;
  }
  .device-row-value {
    font-size: 1rem;
    font-weight: bold;
    flex: 2;
  }
}
</style>
